import { LayoutSpacerSmall } from '@pendwa/common-browser/components/LayoutSpacerSmall/index.js';
import React from 'react';
import { ITileItem, Tile } from '../Tile/index.js';

const ListItem: React.FC<{
  item: ITileItem;
}> = (props) => {
  return (
    <li key={props.item.key}>
      <Tile item={props.item} />
    </li>
  );
};

export const PersonGroupRender: React.FC<{
  group: {
    key: string;
    title: string;
    items: ITileItem[];
  };
}> = (props) => {
  if (props.group.items.length === 0) {
    return null;
  }

  return (
    <LayoutSpacerSmall>
      <h2 className="text-2xl font-extrabold text-gray-900">{props.group.title}</h2>

      <ul className="grid grid-cols-3 gap-x-4 gap-y-8 sm:grid-cols-4 sm:gap-x-6 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-7 xl:gap-x-8">
        {props.group.items.map((item) => (
          <ListItem item={item} key={item.key} />
        ))}
      </ul>
    </LayoutSpacerSmall>
  );
};
